<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen="true" />
      <b-link class="navbar-brand" to="/dashboard" title="Dashboard">
        <img
          class="navbar-brand-full"
          src="img/brand/bsc_logo.png"
          width="89"
          height="25"
          alt="CoreUI Logo"
        />
        <img
          class="navbar-brand-minimized"
          src="img/brand/bsc_logo.png"
          width="30"
          height="30"
          alt="CoreUI Logo"
        />
      </b-link>
        <b-modal id="mod" title="BootstrapVue">
          <p class="my-4">Hello from modal!</p>
        </b-modal>
      <b-navbar-nav class="ml-auto">
        <b-list-group-item
          class="d-flex justify-content-between align-items-center w-100"
          style="border-color: snow;"
        >
          <b-form-checkbox
            id="checkUsuarioAtivo"
            title="Available"
            v-model="usuarioAtivo"
            @change="usuarioAtivoMudou"
            name="check-button"
            switch
          />
        </b-list-group-item>
        <b-nav-item class="d-md-down-none">
          <i v-b-tooltip.hover title="Users online" class="cui-user icons font-2xl d-block"></i>
          <b-badge pill variant="success">{{ usuariosOnline.length }}</b-badge>
        </b-nav-item>
        <b-nav-item class="d-md-down-none" @click="irParaLeadsOnline">
          <i v-b-tooltip.hover title="Visiters online" class="cui-user icons font-2xl d-block"></i>
          <b-badge pill variant="danger">{{ leadsOnline.length }}</b-badge>
        </b-nav-item>
        <DefaultHeaderDropdownAccnt title="Profile" />
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="this.usuarioLogado.roles === 'A' ? nav : navi"/>
        <SidebarFooter class="footerFix" />
        <SidebarMinimizer class="footerFix" />
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list" />
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <DefaultAside />
      </AppAside>
    </div>
    <TheFooter>
      <BarraRodape />
    </TheFooter>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb,
  Switch as cSwitch,
} from '@coreui/vue';
import BarraRodape from '../components/BarraRodape/BarraRodape.vue';
import DefaultAside from './DefaultAside';
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt';
// import cookieUtil from '../utils/cookieUtil.js';


export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    BarraRodape,
    cSwitch,
  },
  data() {
    return {
      navi: [
        {
          name: 'Dashboard',
          url: '/dashboard',
          icon: 'icon-home',
        },
        {
          name: 'Chat',
          url: '/chat',
          icon: 'icon-speech',
        },
        {
          name: 'Visiters on-line',
          url: '/visiterOnLine',
          icon: 'icon-user',
        },
        {
          name: 'Create diagram',
          url: '/CreateDiagram',
          icon: 'icon-user',
        },
      ],

      nav: [
        {
          name: 'Dashboard',
          url: '/dashboard',
          icon: 'icon-home',
        },
        {
          name: 'Chat',
          url: '/chat',
          icon: 'icon-speech',
        },
        {
          name: 'Chat Settings',
          url: '/chatConfiguracoes',
          icon: 'icon-settings',
        },
        {
          name: 'Visiters on-line',
          url: '/visiterOnLine',
          icon: 'icon-user',
        },
        {
          name: 'Create diagram',
          url: '/CreateDiagram',
          icon: 'icon-user',
        },
      ],
      usuarioAtivo: true,
    };
  },
  async created() {

  },
  computed: {
    ...mapGetters(['usuariosOnline', 'leadsOnline', 'usuarioLogado']),
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter((route) => route.name || route.meta.label);
    },
  },
  methods: {
    irParaLeadsOnline() {
      this.$router.push({ name: 'Visiters on-line' });
    },

    async usuarioAtivoMudou(event) {
      try {
        if (event) await this.$socket.open();

        else await this.$socket.close();
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
